import script from "./DashboardSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardSkeleton.vue?vue&type=style&index=0&id=29fd554e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29fd554e"]])

export default __exports__